import { useState } from "react";

export const PersonalizationState = () => {
    // CHANGES NO TOOL CATEGORIES
    const [isSteps, setIsSteps] = useState(
        [
            {selector:'.first-step' , name:'Dashboard', desc:'This serves as your summary transaction.', content:[]},
            {selector:'.second-step' , name:'Trainings', desc:'Experience an Extraordinary Learning.', content:[]},
            {selector:'.third-step' , name:'Certificates', desc:'Save and Upload your certificates.', content:[]},
            // {selector:'.fourth-step' , name:'Be a Trainer', desc:'Share your Extraordinary Learnings.', content:[]},
            {selector:'.fourth-step' , name:'My Professional', desc:'Keep your professional profile accurate and up to date.', content:[]},
            {selector:'.fifth-step' , name:'Tool Categories', desc:'Tools you need for your career growth.', content:[]},
            // {selector:'.fifth-step' , name:'Refer a Hero User', desc:'Earn points by referring a hero user.', content:[]},
            // {selector:'.sixth-step' , name:'Updates', desc:'POFAcademy system updates.', content:[]},
            // {selector:'.seventh-step' , name:'Get App for Desktop', desc:'Download app for easy access.', content:[]},
            {selector:'.fifth-step' , name:'Get App for Desktop', desc:'Download app for easy access.', content:[]},
            {selector:'.eighth-step' , name:'Switch to Personal', desc:'Switch to Personal to grow your career.', content:[]},
            {selector:'.ninth-step' , name:'Switch to Business', desc:'Switch to Business to grow your business.', content:[]},
            {selector:'.tenth-step' , name:'My Tools', desc:'Access your purchased tools here.', content:[]},
        ]
    );
    //ORGINAL
    // const [isSteps, setIsSteps] = useState(
    //     [
    //         {selector:'.first-step' , name:'Dashboard', desc:'This serves as your summary transaction.', content:[]},
    //         {selector:'.second-step' , name:'Trainings', desc:'Experience an Extraordinary Learning.', content:[]},
    //         {selector:'.third-step' , name:'Certificates', desc:'Save and Upload your certificates.', content:[]},
    //         {selector:'.fourth-step' , name:'Be a Trainer', desc:'Share your Extraordinary Learnings.', content:[]},
    //         {selector:'.fifth-step' , name:'Tool Categories', desc:'Tools you need for your career growth.', content:[]},
    //         {selector:'.sixth-step' , name:'Refer a Hero User', desc:'Earn points by referring a hero user.', content:[]},
    //         {selector:'.seventh-step' , name:'Updates', desc:'POFAcademy system updates.', content:[]},
    //         {selector:'.eighth-step' , name:'Get App for Desktop', desc:'Download app for easy access.', content:[]},
    //         {selector:'.ninth-step' , name:'Switch to Personal', desc:'Switch to Personal to grow your career.', content:[]},
    //         {selector:'.tenth-step' , name:'Switch to Business', desc:'Switch to Business to grow your business.', content:[]},
    //         {selector:'.eleventh-step' , name:'My Tools', desc:'Access your purchased tools here.', content:[]},
    //     ]
    // );
    const [welcome, setWelcome] = useState(false);
    const [showTour, setShowTour] = useState(false);
    const [welcomeTour, setWelcomeTour] = useState(false);
    const [personalizationData, setPersonalizationData] = useState([]);
    const [noSidebar, setNoSidebar] = useState(window.location.pathname);
    const [onboarding, setOnboarding] = useState({
        profiling: false, 
        welcome: {stat: false, step: 1},
        home_tour: {
            stat: false, 
            drawer: false, 
            steps: [
                // {selector:'.first-step' , name:'Recent Trainings', desc:'Continue your training where you left off.', content:[]},
                {selector: '.second-step' , name: 'Monitor your Credentials', desc: 'Keep track of your training and uploaded certificates conveniently.', content: []},
                {selector: '.third-step' , name: 'Upload your Certificates', desc: 'Upload your certificate quickly.', content: []},
                {selector: '.fourth-step' , name: 'Switch to main platform', desc: 'You can easily access your primary tools here.', content: []},
                // {selector: '.fifth-step' , name: 'Switch to your favorite tools', desc: 'Instantly access your recently used tools here.', content: []},
            ]
        },
        training: {
            sub: {nav: false, availed: false, referral: false}
        }
    })

    return {
        isSteps:{ data: isSteps, set: setIsSteps},
        showTour:{ data: showTour, set: setShowTour},
        welcome:{ data: welcome, set: setWelcome},
        wt:{ data: welcomeTour, set: setWelcomeTour},
        pd:{ data: personalizationData, set: setPersonalizationData},
        noSidebar:{ data: noSidebar, set: setNoSidebar},
        onboarding:{ data: onboarding, set: setOnboarding}
    }
}
